import { render } from "./MobilePhone.vue?vue&type=template&id=f397fcaa"
import script from "./MobilePhone.vue?vue&type=script&lang=js"
export * from "./MobilePhone.vue?vue&type=script&lang=js"

import "./MobilePhone.vue?vue&type=style&index=0&id=f397fcaa&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__